module.exports = __webpack_public_path__ + "media/images/staffco-brochure-thumbnail-cebcbceafb44ed5bcd9f93cd4a85344f.png";